import React from 'react';
import SideBar from './SideBar';
import TopNav from './TopNav';

const EndShift = () => {
    return (
        <div style={{ display: 'flex' }}>
            <SideBar />
            <div style={{ flex: 1, marginLeft: '250px' }}> {/* Adjust margin to match sidebar width */}
                <TopNav />
                <div className="container" style={{ padding: '20px' }}>
                    <h4 style={{marginTop: 65}}>End Shift</h4>
                    <p>Please complete the following steps to end your shift:</p>
                    <ul>
                        <li>Review your sales for the day.</li>
                        <li>Confirm that all transactions are complete.</li>
                        <li>Log out from the POS system.</li>
                        <li>Submit any cash or inventory reports.</li>
                    </ul>
                    <button className="btn btn-danger">End Shift</button>
                </div>
            </div>
        </div>
    );
};

export default EndShift;